class Token {
    
    /**
     * Create a new token intsance.
     * 
     * @param {String} rawToken
     * 
     * @return {void}
     */
    constructor(rawToken)
    {
        this.rawToken = rawToken;
        this.claims = Token.decodeAndGetClaims(rawToken);
    }

    /**
     * Return the raw token.
     * 
     * @return {String}
     */
    get()
    {
        return this.rawToken;
    }

    /**
     * Decode a JWT token in order to get the claims.
     * 
     * @param {String} rawToken
     * 
     * @return {Array}
     */
    static decodeAndGetClaims(rawToken)
    {
        var tokenArray = rawToken.split('.');
        return JSON.parse(window.atob(tokenArray[1]));
    }
}

export default Token;
